<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import QuestionAnswer from '/src/components/QuestionAnswer.vue'
import QuestionPage from '/src/components/QuestionPage.vue'
import { MDBBtn} from "mdb-vue-ui-kit";
import { mapFields } from 'vuex-map-fields';


export default {
  components: {
    QuestionAnswer,
    QuestionPage,
    MDBBtn,
  },
  computed: {
    ...mapFields([
      'scene.status.leisure'
    ]),
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('leisure')
    }
  },
  methods: {
    ...mapMutations([
      'selectLeisureStatus',
      'goToNextPage',
      'moveToItem'
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectLeisureStatus(1);
      this.leisure = 1
    },
    chooseMedium: function () {
      this.selectLeisureStatus(2);
      this.leisure = 2
    },
    chooseTop: function () {
      this.selectLeisureStatus(3);
      this.leisure = 3
    }
  },
};
</script>

<template>
  <QuestionPage :title="questionAnswerData.question">
    <Transition name="switch" mode="out-in" appear>
      <div v-if="leisure < 2"
        class="question_image question_image_leisure-basic d-block d-sm-none"
      ></div>
      <div v-else-if="leisure == 2"
        class="question_image question_image_leisure-medium d-block d-sm-none"
      ></div>
      <div v-else-if="leisure == 3"
        class="question_image question_image_leisure-top d-block d-sm-none"
      ></div>
    </Transition>

    <!-- show on desktop only -->
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='d-none d-sm-block'
      :onSelect="chooseBasic"
      @click="goToItem('leisure')"
      :imageName="questionAnswerData.images.Q8AA"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='d-none d-sm-block'
      :onSelect="chooseMedium"
      @click="goToItem('leisure')"
      :imageName="questionAnswerData.images.Q8AB"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='d-none d-sm-block'
      :onSelect="chooseTop"
      @click="goToItem('leisure')"
      :imageName="questionAnswerData.images.Q8AC"
    />

    <!-- on mobile only -->
    <div class='d-flex d-sm-none questions-on-mobile'>
      <QuestionAnswer
        :title="questionAnswerData.answers.A"
        class='answer-leisure-basic'
        :onSelect="chooseBasic"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.B"
        class='answer-leisure-medium'
        :onSelect="chooseMedium"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.C"
        class='answer-leisure-top'
        :onSelect="chooseTop"
      />
      <MDBBtn class="next-btn-on-mobile" @click="moveToItem('leisure')">next</MDBBtn>
    </div>
  </QuestionPage>
</template>


